import * as t from "react";
const l = (e) => /* @__PURE__ */ t.createElement(
  "svg",
  {
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ t.createElement(
    "path",
    {
      d: "M7.411 6.74a1.813 1.813 0 01-.67-1.823A1.787 1.787 0 018.099 3.54c.679-.15 1.38.116 1.797.68l7.099 7.199c.676.7.676 1.82 0 2.52l-7.098 7.2a1.756 1.756 0 01-2.32-.167 1.82 1.82 0 01-.165-2.353l5.82-5.94-5.855-5.94h.035z",
      fill: "#2D6DED"
    }
  )
), a = l;
export {
  a as default
};
